import { Link, NavLink, Outlet } from "react-router-dom";

import { AdSenseScript } from "@/components/ads/AdSenseScript";
import { BrandLogo } from "@/components/shared/BrandLogo";
import { CookieConsentBanner } from "@/components/shared/CookieConsentBanner";
import { NewVersionPrompt } from "@/components/shared/NewVersionPrompt";
import { PremiumWaitlistFloater } from "@/components/shared/PremiumWaitlistFloater";
import { ThemeToggle } from "@/components/shared/ThemeToggle";
import { appConfig } from "@/config/app.config";
import { routePaths } from "@/routes/routePaths";

const navItems = [
  { to: "/video-to-text", label: "Video to Text" },
  { to: "/video-caption-generator", label: "Captions" },
  { to: "/video-summary-generator", label: "AI Notes" },
];

export function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-neutral-950 antialiased dark:bg-ink-900 dark:text-neutral-50">
      <AdSenseScript />
      <header className="sticky top-0 z-20 border-b border-neutral-200 bg-white/95 backdrop-blur dark:border-neutral-800 dark:bg-ink-900/95">
        <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:px-6">
          <Link
            to={routePaths.home}
            className="min-w-0"
            aria-label={`${appConfig.name} home`}
          >
            <BrandLogo />
          </Link>
          <nav className="hidden items-center gap-5 text-sm text-neutral-600 dark:text-neutral-300 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  isActive
                    ? "text-neutral-950 dark:text-white"
                    : "transition hover:text-neutral-950 dark:hover:text-white"
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <ThemeToggle />
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <PremiumWaitlistFloater />
      <NewVersionPrompt />
      <CookieConsentBanner />
      <footer className="border-t border-neutral-200 py-8 dark:border-neutral-800">
        <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 text-sm text-neutral-600 dark:text-neutral-400 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <p>
            {appConfig.name} turns your media into text without storing the file
            or transcript.
          </p>
          <div className="flex gap-4">
            <Link
              to={routePaths.privacy}
              className="hover:text-neutral-950 dark:hover:text-white"
            >
              Privacy
            </Link>
            <Link
              to={routePaths.terms}
              className="hover:text-neutral-950 dark:hover:text-white"
            >
              Terms
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
